var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer",style:({color: _vm.color})},[_c('div',{staticClass:"pointer__marker",style:({transform: 'translate(-50%,-50%) rotate(' + _vm.position * 380 + 'deg)'})})])}
var staticRenderFns = []

export { render, staticRenderFns }